'use client';

import { colors } from '@/lib/mx-asurion-ui-react';
import styled from 'styled-components';

export const DisclaimerArea = styled.div`
  grid-area: disclaimerArea;
`;

export const GridLayout = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 320px auto;
  grid-template-areas:
    'logoArea linksArea'
    'disclaimerArea disclaimerArea';

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 1rem;
    grid-template-areas:
      'logoArea'
      'disclaimerArea'
      'linksArea';
  }
`;

export const LinksArea = styled.div`
  grid-area: linksArea;
`;

export const LogoArea = styled.div`
  grid-area: logoArea;
`;

export const StyledFooter = styled.footer`
  box-sizing: border-box;
  padding: 2rem 0;
  background: ${colors.white};
  color: ${colors.black};
  width: 100%;
  max-width: 1440px;
  min-height: 13rem;
  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const StyledFooterDisclaimer = styled.section``;

export const StyledFooterLinks = styled.ul`
  margin: 0.5rem 0 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-flow: row wrap;
  justify-content: end;
  row-gap: 1rem;

  li::after {
    padding: 0 0.5rem;
    content: '|';
  }
  li:last-child::after {
    content: '';
  }

  @media (max-width: 768px) {
    justify-content: start;
  }
`;

export const StyledFooterWrapper = styled.div`
  width: 100%;
  background: ${colors.white};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 0 2rem;
  box-sizing: border-box;
  border-top: 1px solid ${colors.neutralBrighter};
`;
